import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterContentType } from '@/components/ui/features/hubs-conference/LibraryFilter/components/FilterContentType';
import { FilterItem } from '@/components/ui/features/hubs-conference/LibraryFilter/components/FilterItem';
import { FilterPublisher } from '@/components/ui/features/hubs-conference/LibraryFilter/components/FilterPublisher';
import { FilterReleaseYear } from '@/components/ui/features/hubs-conference/LibraryFilter/components/FilterReleaseYear';
import { Filters } from '@/components/ui/features/hubs-conference/LibraryFilter/components/Filters';
import { FilterSubjects } from '@/components/ui/features/hubs-conference/LibraryFilter/components/FilterSubjects';
import { LibraryFilter as LibraryFilterEnum } from '@/enums/LibraryFilter';

export const LibraryFilter: FC<BoxProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      <Box h="full" overflowY="auto" layerStyle="blackScrollbar">
        <Filters allowToggle allowMultiple reduceMotion>
          <FilterItem title={t('library.filter.subject')} parameter={LibraryFilterEnum.Subject}>
            <FilterSubjects />
          </FilterItem>
          <FilterItem title={t('library.filter.society')} parameter={LibraryFilterEnum.Publisher}>
            <FilterPublisher />
          </FilterItem>
          <FilterItem title={t('library.filter.contentType')} parameter={LibraryFilterEnum.Tag}>
            <FilterContentType />
          </FilterItem>
          <FilterItem title={t('library.filter.releaseYear')} parameter={LibraryFilterEnum.Year}>
            <FilterReleaseYear />
          </FilterItem>
        </Filters>
      </Box>
    </Box>
  );
};
